import LegalLayout from "./LegalLayout";

export default function TermsOfSale() {
  return (
    <LegalLayout title="Conditions générales de vente" updated="23 juillet 2026">
      <p>
        Les présentes conditions générales de vente régissent les commandes effectuées auprès de{" "}
        <strong>Délices Mikaté Royal</strong> via le site{" "}
        <a href="https://www.mikateroyal.com" target="_blank" rel="noreferrer">www.mikateroyal.com</a>.
      </p>

      <h2>1. Présentation de l&apos;entreprise</h2>
      <p>
        Délices Mikaté Royal est une entreprise spécialisée dans la préparation artisanale de mikatés et
        de produits alimentaires inspirés des traditions africaines.
      </p>

      <h2>2. Acceptation des conditions</h2>
      <p>
        Toute commande effectuée auprès de Délices Mikaté Royal implique l&apos;acceptation complète des
        présentes conditions générales de vente.
      </p>
      <p>
        Le client reconnaît avoir pris connaissance des informations relatives aux produits, aux prix et
        aux modalités de commande avant de confirmer son achat.
      </p>

      <h2>3. Commandes</h2>
      <p>Les commandes doivent être effectuées via les moyens proposés sur le site.</p>
      <p>
        Une commande est considérée comme confirmée lorsque le client reçoit une confirmation de commande
        ou une confirmation par courriel.
      </p>
      <p>
        Délices Mikaté Royal se réserve le droit de refuser ou d&apos;annuler une commande en cas
        d&apos;erreur manifeste, d&apos;indisponibilité d&apos;un produit ou de circonstances
        exceptionnelles.
      </p>

      <h2>4. Produits alimentaires</h2>
      <p>Nos produits sont préparés artisanalement avec soin.</p>
      <p>
        Comme il s&apos;agit de produits alimentaires frais, leur apparence, leur texture ou leur
        présentation peuvent varier légèrement d&apos;une préparation à l&apos;autre.
      </p>
      <p>Ces variations n&apos;affectent pas la qualité ni la conformité des produits.</p>

      <h2>5. Prix et taxes</h2>
      <p>Les prix affichés sur le site sont indiqués en dollars canadiens (CAD).</p>
      <p>
        Délices Mikaté Royal se réserve le droit de modifier ses prix à tout moment. Les prix applicables
        sont ceux affichés au moment de la confirmation de la commande.
      </p>

      <h2>6. Paiement</h2>
      <p>Les modes de paiement acceptés sont ceux indiqués sur le site&nbsp;:</p>
      <ul>
        <li>Virement Interac (recommandé)&nbsp;;</li>
        <li>PayPal&nbsp;;</li>
        <li>Argent comptant à la livraison.</li>
      </ul>
      <p>
        La commande peut nécessiter une confirmation du paiement avant sa préparation. Aucune donnée
        bancaire n&apos;est collectée ni stockée par Délices Mikaté Royal.
      </p>

      <h2>7. Commandes pour événements</h2>
      <p>
        Pour les commandes importantes ou les événements, des informations supplémentaires peuvent être
        demandées&nbsp;:
      </p>
      <ul>
        <li>date de l&apos;événement&nbsp;;</li>
        <li>nombre de personnes&nbsp;;</li>
        <li>quantité souhaitée&nbsp;;</li>
        <li>besoins particuliers.</li>
      </ul>
      <p>
        Une soumission ou une confirmation spécifique peut être établie selon la nature de la demande.
      </p>

      <h2>8. Préparation et disponibilité</h2>
      <p>Les commandes sont préparées selon les disponibilités et les délais indiqués au client.</p>
      <p>
        Délices Mikaté Royal s&apos;engage à préparer les commandes avec soin, mais ne peut être tenu
        responsable des retards causés par des événements hors de son contrôle.
      </p>

      <h2>9. Responsabilités du client</h2>
      <p>Le client doit fournir des informations exactes lors de sa commande, notamment&nbsp;:</p>
      <ul>
        <li>coordonnées&nbsp;;</li>
        <li>adresse de livraison&nbsp;;</li>
        <li>informations nécessaires à la préparation de la commande.</li>
      </ul>
      <p>Le client est responsable de vérifier l&apos;exactitude des informations transmises.</p>

      <h2>10. Produits allergènes</h2>
      <p>
        Le client doit informer Délices Mikaté Royal de toute allergie ou restriction alimentaire avant
        de commander.
      </p>
      <p>
        Bien que nous prenions des précautions raisonnables, certains produits peuvent contenir ou avoir
        été en contact avec des allergènes.
      </p>

      <h2>11. Annulation et remboursement</h2>
      <p>
        Les conditions d&apos;annulation et de remboursement sont décrites dans notre
        <a href="/politique-remboursement"> Politique de remboursement et de retour</a>.
      </p>

      <h2>12. Protection des renseignements personnels</h2>
      <p>
        Les renseignements recueillis lors d&apos;une commande sont traités conformément à notre
        <a href="/politique-confidentialite"> Politique de confidentialité</a>.
      </p>

      <h2>13. Modifications des conditions générales</h2>
      <p>
        Délices Mikaté Royal se réserve le droit de modifier les présentes conditions générales de vente
        à tout moment.
      </p>
      <p>La version applicable est celle publiée sur le site au moment de la commande.</p>

      <h2>14. Contact</h2>
      <p>
        <strong>Délices Mikaté Royal</strong><br />
        Site Web&nbsp;: <a href="https://www.mikateroyal.com" target="_blank" rel="noreferrer">www.mikateroyal.com</a><br />
        Courriel&nbsp;: <a href="mailto:contact@mikateroyal.com">contact@mikateroyal.com</a>
      </p>
    </LegalLayout>
  );
}
